import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VBPercentageInfo, VBTypesInfo } from '@/components/VirtualBattery/types/virtualBattery';

export interface IVirtualBatteryState {
  isFetchingBateriaVirtualTypes: boolean;
  isFetchingBateriaVirtualPercentages: boolean;
  isWaitingChangeRequest: boolean;
  bateriaVirtualPercentages: VBPercentageInfo[];
  virtualBatteryTypes: VBTypesInfo[];
}

const initialState: IVirtualBatteryState = {
  isFetchingBateriaVirtualTypes: false,
  isFetchingBateriaVirtualPercentages: false,
  isWaitingChangeRequest: false,
  bateriaVirtualPercentages: [],
  virtualBatteryTypes: []
};

export const virtualBatterySlice = createSlice({
  name: 'virtualBattery',
  initialState,
  reducers: {

    // Types
    typesRequested: (state) => {  
      state.isFetchingBateriaVirtualTypes = true;
    },
    typesReceived: (state, action: PayloadAction<VBTypesInfo[]>) => {
      state.isFetchingBateriaVirtualTypes = false;
      state.virtualBatteryTypes = action.payload;
    },

    // Percentage
    percentagesReceived: (state, action: PayloadAction<VBPercentageInfo[]>) => {
      state.bateriaVirtualPercentages = action.payload.map(
        e => Object.assign(e, {percentage: parseInt(e.percentage.toFixed(0))})
      ),
      state.isFetchingBateriaVirtualPercentages = false;
    },
    percentagesFetched: (state) => {  
      state.bateriaVirtualPercentages = [];
      state.isFetchingBateriaVirtualPercentages = true;
    },
    percentageSetRequested: (state) => {
      state.isWaitingChangeRequest = true;
    },
    percentageSetDone: (state) => {
      state.isWaitingChangeRequest = false;
    },
    percentageSetError: (state) => {
      state.isWaitingChangeRequest = false;
    },

    // Move
    batteryMoveRequest: (state) => {
      state.isWaitingChangeRequest = true;
    },
    batteryMoveDone: (state) => {
      state.isWaitingChangeRequest = false;
    },
    batteryMoveError: (state) => {
      state.isWaitingChangeRequest = false;
    }
  }
})

export const actions = virtualBatterySlice.actions;

export default virtualBatterySlice.reducer;